'use strict';

module.exports = function () {
    if (this && this.parent) {
        return this.parent().status === 'Lite';
    }

    return this.status === 'Lite';
};